import React from "react";

const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="relative bg-[#0A0A0A] text-zinc-400 border-t border-white/10"
    >
      <div className="mx-auto max-w-7xl px-6 py-14">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8">
          <img
            src="/brand/volotag-logo-cropped.png"
            alt="VoloTag"
            className="h-12 md:h-14 w-auto rounded-lg"
          />

          <div className="flex flex-wrap gap-x-8 gap-y-3 text-sm">
            <a href="#product" className="hover:text-white transition">Product</a>
            <a href="#how" className="hover:text-white transition">How it works</a>
            <a href="#why" className="hover:text-white transition">Why VoloTag</a>
            <a href="#faq" className="hover:text-white transition">FAQ</a>
            <a href="#waitlist" className="hover:text-white transition">Waitlist</a>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-zinc-500">
          <p>© {new Date().getFullYear()} VoloTag — a product of Verified Digital Solutions.</p>
          <p className="tracking-widest uppercase">Built for everyday life.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
